import { Star } from "lucide-react";

// Shared 1-5 star rating control (Part A, 2026-02) — the Interview page's Interviewer Capture
// zone uses TWO of these side by side (Attitude Rating + Overall Rating, separate scales,
// never conflated); Past Interviews' read-only detail view reuses the same read-only variant
// so both pages render identically.
export function RatingStars({ value, onChange, testIdPrefix }) {
  return (
    <div className="flex items-center gap-1" data-testid={`${testIdPrefix}-stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n === value ? null : n)} data-testid={`${testIdPrefix}-star-${n}`}
          className="transition-transform hover:scale-110">
          <Star className={`h-5 w-5 ${value >= n ? "fill-brand text-brand" : "text-hairline"}`} strokeWidth={1.5} />
        </button>
      ))}
      {value != null && <span className="text-xs text-faint ml-1">{value}/5</span>}
    </div>
  );
}

export function StarsReadOnly({ value, testId }) {
  if (value == null) return <span className="text-faint text-xs" data-testid={testId}>—</span>;
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-3.5 w-3.5 ${value >= n ? "fill-brand text-brand" : "text-hairline"}`} strokeWidth={1.5} />)}
    </div>
  );
}
